var ReactTimeAgo = require('./commonjs/ReactTimeAgo').default;

exports = module.exports = ReactTimeAgo;
exports['default'] = ReactTimeAgo;